<template>
    
<h1>婴儿培养箱</h1>

</template>

<script>
export default {
        
    data(){

        return {

        }
    }

}
</script>